import Capsules from './Capsules';

export {buildCapsules, CAPSULE_TYPES} from './buildCapsules';
export default Capsules;
